// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3YcZG","container":"footer-module--container--SePS1","left":"footer-module--left--2AU-g","right":"footer-module--right--2vSVm"};